<form #accountsettingsform="ngForm" name="accountsettingsform" (ngSubmit)="onSubmit()" class="mb-0">

<div class="fieldset fieldset--lg" style="margin-bottom: 15px;">
  <p class="form-info-p">All fees you collect will be settled to the account you specify below</p>
</div>
<div class="fieldset fieldset--lg">
  <label class="legend" for="bankId">Select Your Bank</label>
  <ng-select aria-required="true" [(ngModel)]="schooInfo.bankId" name="bankId" id="bankId" ngDefaultControl #bankIdField>
    <ng-option *ngFor="let bank of banks" [value]="bank.id">{{bank.name}}</ng-option>
  </ng-select>
</div>
<div class="fieldset--lg d-flex flex-column flex-md-row m-auto mw-100">
  <div class="fieldset fieldset--lg flex-fill mr-md-3">
    <label class="legend" for="accountName">Account Name</label>
    <input type="text" [(ngModel)]="schooInfo.accountName" #accountName required name="accountName" class="text-field" id="accountName">
  </div>
  <div class="fieldset fieldset--lg flex-fill">
    <label class="legend" for="accountNumber">Account Number</label>
    <input type="text" [(ngModel)]="schooInfo.accountNumber" #accountNumber required name="accountNumber" class="text-field" id="accountNumber">
  </div></div>
  <div class="d-flex justify-content-center flex-wrap gap-1.5 mt-5">
      <button class="btn m-0" [disabled]="this.accountsettingsform.invalid || isSubmitting" type="submit">Save</button>
      <button class="btn btn--warning m-0" routerLink="/account/accountsettings">Cancel</button>  
</div>
</form>